import React, { useState } from 'react';
import { RARITIES, SOURCE_OPTIONS, LANGUAGE_OPTIONS } from '../../utils/constants';

export default function CardFilters({ filters, onFilterChange }) {
  const [expanded, setExpanded] = useState(false);
  const [local, setLocal] = useState({
    card_name: filters.card_name || '',
    rarity: filters.rarity || '',
    extension: filters.extension || '',
    source: filters.source || '',
    language: filters.language || '',
    min_price: filters.min_price || '',
    max_price: filters.max_price || '',
    linked: filters.linked || '',
  });

  const handleChange = (field, value) => {
    setLocal((prev) => ({ ...prev, [field]: value }));
  };

  const handleApply = () => {
    const cleaned = {};
    Object.entries(local).forEach(([key, value]) => {
      if (value !== '' && value !== null) cleaned[key] = value;
    });
    onFilterChange(cleaned);
  };

  const handleClear = () => {
    const empty = {
      card_name: '', rarity: '', extension: '',
      source: '', language: '', min_price: '', max_price: '', linked: '',
    };
    setLocal(empty);
    onFilterChange({});
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleApply();
  };

  return (
    <div className="card-filters">
      <div className="filters-header">
        <button
          className="btn btn-sm"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? 'Hide Filters' : 'Show Filters'}
        </button>
      </div>
      {expanded && (
        <div className="filters-body" onKeyDown={handleKeyDown}>
          <div className="filter-row">
            <div className="filter-field">
              <label>Card Name</label>
              <input
                type="text"
                value={local.card_name}
                onChange={(e) => handleChange('card_name', e.target.value)}
                placeholder="Search by name..."
              />
            </div>
            <div className="filter-field">
              <label>Extension / Set</label>
              <input
                type="text"
                value={local.extension}
                onChange={(e) => handleChange('extension', e.target.value)}
                placeholder="e.g. Evolving Skies"
              />
            </div>
            <div className="filter-field">
              <label>Rarity</label>
              <select
                value={local.rarity}
                onChange={(e) => handleChange('rarity', e.target.value)}
              >
                <option value="">All</option>
                {RARITIES.map((r) => (
                  <option key={r.abbr} value={r.abbr}>{r.abbr} - {r.name}</option>
                ))}
              </select>
            </div>
            <div className="filter-field">
              <label>Source</label>
              <select
                value={local.source}
                onChange={(e) => handleChange('source', e.target.value)}
              >
                <option value="">All</option>
                {SOURCE_OPTIONS.map((s) => (
                  <option key={s.value} value={s.value}>{s.label}</option>
                ))}
              </select>
            </div>
            <div className="filter-field">
              <label>Language</label>
              <select
                value={local.language}
                onChange={(e) => handleChange('language', e.target.value)}
              >
                <option value="">All</option>
                {LANGUAGE_OPTIONS.map((l) => (
                  <option key={l.value} value={l.value}>{l.label}</option>
                ))}
              </select>
            </div>
            <div className="filter-field">
              <label>TCG Link</label>
              <select
                value={local.linked}
                onChange={(e) => handleChange('linked', e.target.value)}
              >
                <option value="">All</option>
                <option value="linked">Linked</option>
                <option value="unlinked">Unlinked</option>
              </select>
            </div>
            <div className="filter-field">
              <label>Min Price</label>
              <input
                type="number"
                value={local.min_price}
                onChange={(e) => handleChange('min_price', e.target.value)}
                placeholder="0"
                min="0"
                step="0.01"
              />
            </div>
            <div className="filter-field">
              <label>Max Price</label>
              <input
                type="number"
                value={local.max_price}
                onChange={(e) => handleChange('max_price', e.target.value)}
                placeholder="999"
                min="0"
                step="0.01"
              />
            </div>
          </div>
          <div className="filter-actions">
            <button className="btn btn-primary" onClick={handleApply}>Apply</button>
            <button className="btn" onClick={handleClear}>Clear</button>
          </div>
        </div>
      )}
    </div>
  );
}
